import FoodMenuIcon from '@material-ui/icons/ViewList';

import EduSchoolList from './EduSchoolList';

export default {
  list: EduSchoolList,
  icon: FoodMenuIcon,
};
